import {
  IOrganizationUploader,
  OrganizationInDto,
  UploadOrganization,
  UploadOrganizationChanges,
} from 'shared/domain/organization/types/dto';
import type { IHttpRequestRunner } from 'shared/domain/httpRequest/httpRequestRunner';
import {
  OrganizationHttpCreateRequestModel,
  OrganizationHttpEditRequestModel,
} from './types';

export class OrganizationRequestRunner implements IHttpRequestRunner {
  constructor(
    private organizationUploader: IOrganizationUploader,
    private uploadOrganizationUseCase: UploadOrganization,
    private saveOrganization: (
      data: OrganizationInDto
    ) => Promise<unknown>,
    private uploadOrganizationChangesUseCase: UploadOrganizationChanges
  ) {}
  async execute(
    request:
      | OrganizationHttpCreateRequestModel
      | OrganizationHttpEditRequestModel
  ): Promise<unknown> {
    switch (request.method) {
      case 'POST': {
        return this.uploadOrganization(
          request
        );
      }
      case 'PUT': {
        return this.uploadOrganizationChanges(
          request
        );
      }
    }
  }

  /** Stores what the server saved, so reads of the created organization are current. */
  private async uploadOrganization(
    request: OrganizationHttpCreateRequestModel
  ): Promise<OrganizationInDto> {
    const organizationInDto = await this.uploadOrganizationUseCase(
      this.organizationUploader,
      request.data.organizationCreateOutDto,
      request.url
    );
    await this.saveOrganization(organizationInDto);
    return organizationInDto;
  }

  /** Stores what the server saved, so reads after the edit are current. */
  private async uploadOrganizationChanges(
    request: OrganizationHttpEditRequestModel
  ): Promise<OrganizationInDto> {
    const organizationInDto = await this.uploadOrganizationChangesUseCase(
      this.organizationUploader,
      request.data.organizationEditOutDto,
      request.url
    );
    await this.saveOrganization(organizationInDto);
    return organizationInDto;
  }
}
